import { render, staticRenderFns } from "./action-btn.vue?vue&type=template&id=0dafffca&scoped=true"
import script from "./action-btn.ts?vue&type=script&lang=ts&external"
export * from "./action-btn.ts?vue&type=script&lang=ts&external"
import style0 from "./action-btn.scss?vue&type=style&index=0&id=0dafffca&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dafffca",
  null
  
)

export default component.exports